import { Typography } from 'antd';
import React, { useMemo } from 'react';
import settings from '../../../../settings';

const { Text } = Typography;

function ProjectBubbles({ project }) {
  const bubbles = useMemo(() => {
    if (project) {
      return [
        project.peopleGroupIds &&
          project.peopleGroupIds.length > 0 && {
            text: (
              <div>
                <Text style={{ color: settings.colors.black, fontSize: 16 }}>
                  Grants access to
                </Text>
                <br />
                <Text
                  style={{
                    color: settings.colors.white,
                    fontSize: 32,
                    fontWeight: 800,
                  }}
                >
                  {project.peopleGroupIds.length}
                </Text>
                <br />
                <Text style={{ color: settings.colors.black, fontSize: 16 }}>
                  Unreached People Groups
                </Text>
              </div>
            ),
          },
        project.numSupported > 0 && {
          text: (
            <div>
              <Text style={{ color: settings.colors.black, fontSize: 16 }}>
                Provids funding for
              </Text>
              <br />
              <Text
                style={{
                  color: settings.colors.white,
                  fontSize: 32,
                  fontWeight: 800,
                }}
              >
                {project.numSupported}
              </Text>
              <br />
              <Text style={{ color: settings.colors.black, fontSize: 16 }}>
                Native Missionaries
              </Text>
            </div>
          ),
        },
        project.region && {
          text: (
            <div>
              <Text style={{ color: settings.colors.black, fontSize: 16 }}>
                Helps bring a gospel movement to
              </Text>
              <br />
              <Text
                style={{
                  color: settings.colors.white,
                  fontSize: 20,
                  fontWeight: 600,
                }}
              >
                {project.region}
              </Text>
            </div>
          ),
        },
      ].filter((a) => a);
    }
    return [{}, {}, {}];
  }, [project]);
  return (
    <div className="container">
      {bubbles.map((bubble, index) => (
        <div className="bubble" key={index}>
          {bubble.text}
        </div>
      ))}
      <style jsx>{`
        .container {
          display: flex;
          justify-content: center;
          margin-bottom: 28px;
          margin-right: -12px;
          margin-right: -12px;
          flex-wrap: wrap;
        }
        .bubble {
          background-color: ${settings.colors.holisticGreen};
          border-radius: 50%;
          height: 240px;
          width: 240px;
          margin-right: 12px;
          margin-left: 12px;
          margin-bottom: 12px;
          color: white;
          display: flex;
          justifiy-content: center;
          align-items: center;
          text-align: center;
          padding: 32px;
          font-size: 16px;
          font-weight: 500;
          letter-spacing: 1.5px;
        }
      `}</style>
    </div>
  );
}

export default ProjectBubbles;
